import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Button, Form } from 'reactstrap';
import { connect } from 'react-redux';

import FormFooter from '../../../../common/forms/FormFooter';
import DynamicForm from '../../../../common/forms/DynamicForm';

import { ITINERARY_SCHEDULE_FOOD_COLUMNS } from '../../../../../config/dynamicFormFields';

const ItineraryFoodForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  loading,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <h3>Alimentación</h3>

    <DynamicForm
      name="itineraryScheduleFoodRequestList"
      columns={ITINERARY_SCHEDULE_FOOD_COLUMNS}
    />

    <FormFooter
      saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
      saveButtonDisabled={loading}
    >
      <Button color="danger" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

ItineraryFoodForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ItineraryFoodForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.ItineraryUnit.ItineraryAdditionalFood.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'ItineraryFoodForm',
})(ItineraryFoodForm);

export default connect(mapStateToProps)(formComponent);
